import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 20px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "Pijltje naar rechts",
  viewBox: "0 0 20 25"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "8.2,17.4 10.3,19.5 17.8,12.1 10.3,4.5 8.2,6.7 13.5,12.1 "
})));